import React, { useEffect, useState } from "react";
import { FaFileExcel, FaTrash } from "react-icons/fa";
import "./ProgressStages.css";

// stop spreadsheet formulas from running in exported cells
const safe = (v) => {
  const s = String(v ?? "");
  return `"${(/^[=+\-@]/.test(s) ? "'" + s : s).replace(/"/g, '""')}"`;
};

const ProgressStages = () => {
  const [rows, setRows] = useState([]); // [{ name, sortOrder }] - connect your API here
  const [search, setSearch] = useState("");
  const [menu, setMenu] = useState(false);

  useEffect(() => {
    const close = () => setMenu(false);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  const q = search.trim().toLowerCase();
  const shown = rows.map((r, i) => ({ ...r, i })).filter((r) => !q || String(r.name).toLowerCase().includes(q));
  const n = shown.length;
  const entries = `Showing ${n ? 1 : 0} to ${n} of ${n} entries`;

  const update = (i, key, val) => setRows(rows.map((r, j) => (j === i ? { ...r, [key]: val } : r)));

  // Export to Excel (CSV opens directly in Excel)
  const exportExcel = () => {
    const csv = ["Name,Sort Order", ...shown.map((r) => `${safe(r.name)},${safe(r.sortOrder)}`)].join("\r\n");
    const url = URL.createObjectURL(new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = "progress-stages.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    setMenu(false);
  };

  return (
    <div className="ps-page">
      <h3 className="ps-title">Progress Stages</h3>
      <div className="ps-panel">
        <div className="ps-toolbar">
          <label className="ps-search">
            <b>Search:</b>
            <input value={search} onChange={(e) => setSearch(e.target.value)} />
          </label>

          <div className="ps-split">
            <button type="button" className="ps-btn ps-add" onClick={() => setRows([...rows, { name: "", sortOrder: rows.length + 1 }])}>
              <span className="ps-plus">+</span> Add
            </button>
            <button type="button" className="ps-btn ps-caret" onClick={(e) => { e.stopPropagation(); setMenu(!menu); }}>
              ▾
            </button>
            {menu && (
              <div className="ps-menu">
                <button type="button" onClick={exportExcel}><FaFileExcel /> <span>Export to Excel</span></button>
              </div>
            )}
          </div>
        </div>

        <div className="ps-entries">{entries}</div>

        <table className="ps-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Sort Order</th>
              {n > 0 && <th className="ps-x" />}
            </tr>
          </thead>
          <tbody>
            {n === 0 ? (
              <tr><td colSpan={2} className="ps-empty">No data available in table</td></tr>
            ) : (
              shown.map((r) => (
                <tr key={r.i}>
                  <td><input className="ps-input" value={r.name} onChange={(e) => update(r.i, "name", e.target.value)} /></td>
                  <td><input className="ps-input ps-num" type="number" value={r.sortOrder} onChange={(e) => update(r.i, "sortOrder", e.target.value)} /></td>
                  <td className="ps-x">
                    <button type="button" className="ps-ibtn" title="Delete" onClick={() => setRows(rows.filter((_, j) => j !== r.i))}><FaTrash /></button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div className="ps-foot">
          <span>{entries}</span>
          <span className="ps-arrows">‹ &nbsp; ›</span>
        </div>
      </div>
    </div>
  );
};

export default ProgressStages;